<div
  class="challenge-account-type"
  [class]="'challenge-account-type--' + accountType.toLowerCase()"
>
  {{ label }}
</div>
